
const dataDicObj = {
    //'TAX_TYPE': 8,//税种
    // 'DEDUCTIBLE': 9,//可否抵扣
    // 'COMPUTE_LOGIC': 10,// 计算逻辑
    // 'DOCUMENT_TYPE': 72, //凭证场景类型
    // 'SUBJECT_TYPE': 63, //场景类型
    // 'SUBENTRY_LINE_TYPE': 101, //分录行场景
    // 'TRANSACTION_TYPE': 86,//事务处理类型
    'UPLOAD_STATUS': 93,//上传状态
    'RENTAL_ITEM_DETAIL_NAV': 115 ,//租赁物件详细信息导航
    'RENTAL_ITEM_DETAIL_NAV_EN': 132 , //租赁物件详细信息导航(EN)
    'REPORT_NAME': 111,//报表名称

}

export default dataDicObj


// WEBPACK FOOTER //
// ./src/api/common/dataDictionary.js